import { Divider, Paper, Skeleton, styled } from '@mui/material';


export const StyledPaperCard = styled(Paper)(({ theme }) => ({
  display: 'inline-block',
  margin: theme.spacing(1),
  minWidth: 150,
  padding: theme.spacing(1),
  textAlign: 'center',
}));

export const StyledTypographyTitle = styled('h2')(({ theme }) => ({
  fontSize: theme.spacing(1.75),
  textTransform: 'uppercase',
  fontWeight: 400,
  lineHeight: '21px',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  height: 2,
  margin: `${theme.spacing(0.5)} auto`,
}));

export const StyledSkeleton = styled(Skeleton)(() => ({
  height: 21,
}));

export const StyledTypographyValue = styled('p')(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.spacing(2.25),
  marginBottom: 0,
  lineHeight: '21px',
}));
